import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Tooltip } from '../../../common/tooltip'
import { TranslateRemoveMultiCompany } from '../../common/html/text/TranslateCompany'
import { TranslateItemSelect } from '../../common/html/text/TranslateItem'
import { PopupCopyOrMoveCompany } from '../../common/popup/PopupCopyOrMoveCompany'
import { PopupDeleteCompany } from '../../common/popup/PopupDeleteCompany'
import { TYPE_DELETE } from '../../constant'
import { checkIsSelectAll, getListIdSelectByObj } from '../../helper'
import { TYPE_POPUP_MOVE_COPY } from '../../savedPortfolios/detailsPortfolios/constant'
import { postCopyCompany } from '../../savedPortfolios/detailsPortfolios/store/thunk'
import { changeFragment } from '../../savedPortfolios/portfoliosOverview/store/slice/sliceComponent'

import { IDS_REPORT } from '../../../cartAndOrders/constant'
import { getCompanies } from '../../../common/filterCompany/store/thunk'
import { AddToCart } from '../../../common/order/cart'
import EventEmitter, { SHOW_POPUP_ERROR } from '../../../helpers/EventEmitter'
import { COMPANY_TYPES } from '../../../utils/common'
import classes from '../index.module.scss'
import {
  removeIdInListIdAll,
  selectAllIdByTerm,
  selectDataCheckBox,
  unSelectAllCheckbox,
} from '../store/slice'
import { delUnFollow, getHeaderFollow } from '../store/thunk'

export const InteractiveTable = () => {
  const dispatch = useDispatch()

  const checkboxObj = useSelector(selectDataCheckBox('listIdsSelected'))
  const listIdAllByTerm = useSelector(selectDataCheckBox('listIdAllByTerm'))
  const locale = useSelector((state) => state.i18n.locale)

  const isShowInteractive = Object.values(checkboxObj).some(Boolean)
  const numberIdSelected = Object.values(checkboxObj).reduce(
    (accumulator, currentValue) =>
      currentValue ? accumulator + currentValue : accumulator,
    0,
  )
  const isSelectAllIdByTerm = checkIsSelectAll(listIdAllByTerm, checkboxObj)
  const textFollowing = UseI18n('library.main.FOLLOWING_LIST')

  const [isShowCopy, setShowCopy] = useState(false)
  const [isShowDelete, setIsShowDelete] = useState(false)

  const handleSelectAllPortfolio = (value) => {
    dispatch(selectAllIdByTerm(value))
  }

  const handleUnSelectAllPortfolio = () => {
    dispatch(unSelectAllCheckbox())
  }

  const handleDelete = () => {
    setIsShowDelete(true)
  }

  const onSubmitDelete = () => {
    dispatch(
      delUnFollow({
        organizationIds: getListIdSelectByObj(checkboxObj),
        deleteType: TYPE_DELETE.IN,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(changeFragment())
        setIsShowDelete(false)
        dispatch(getHeaderFollow({}))
        handleUnSelectAllPortfolio()
        dispatch(removeIdInListIdAll(getListIdSelectByObj(checkboxObj)))
      })
      .catch(() => {})
  }

  const onSubmitCopy = (listPort) => {
    dispatch(
      postCopyCompany({
        organizationIds: [...getListIdSelectByObj(checkboxObj)],
        targetPorfolioIds: [...listPort],
      }),
    )
      .unwrap()
      .then(() => {
        handleUnSelectAllPortfolio()
        setShowCopy(false)
      })
      .catch(() => {})
  }

  const handleBuyAndAddCart = (isAdd, handleAddCart) => {
    dispatch(
      getCompanies({
        page: 1,
        pageSize: 500,
        organizationIds: [...getListIdSelectByObj(checkboxObj)],
      }),
    )
      .unwrap()
      .then((data) => {
        const listData = data
          .filter((key) =>
            [
              COMPANY_TYPES.BANK,
              COMPANY_TYPES.CORPORATE,
              COMPANY_TYPES.SECURITIES,
            ].includes(key?.companyType),
          )
          .map((item) => ({
            organizationId: item?.organizationId,
            taxCode: item?.taxCode,
            companyName: item?.organizationName,
            languageCode: locale,
            fiinGateReportTypeId: IDS_REPORT.FIINGATE_FACTSHEET,
          }))

        if (!listData.length) {
          EventEmitter.dispatch(SHOW_POPUP_ERROR, {
            messages: [
              <div className="textCenter">
                <Translate
                  reportName="FiinGate FactSheet"
                  value="common.order.popupConfirmationBuyNowOrAddCart.TITLE_LINE_2"
                />
              </div>,
            ],
          })
          return
        }

        handleAddCart(isAdd, listData)
      })
      .catch(() => {})
  }

  return (
    <>
      {isShowInteractive && (
        <Element
          className={['dFlex alignItemsCenter', classes.listActionIcon].join(
            ' ',
          )}
        >
          {isShowInteractive && (
            <>
              <Element elementName="p" className="fw600">
                <TranslateItemSelect count={numberIdSelected} />
              </Element>
              {isSelectAllIdByTerm ? (
                <Element
                  elementName="p"
                  className="cursorPointer fw600"
                  style={{
                    color: '#2C73E8',
                  }}
                  onClick={() => handleUnSelectAllPortfolio()}
                >
                  <Translate value="library.main.UNSELECT_ALL" />
                </Element>
              ) : (
                <Element
                  elementName="p"
                  className="cursorPointer fw600"
                  style={{
                    color: '#2C73E8',
                  }}
                  onClick={() => handleSelectAllPortfolio(true)}
                >
                  <Translate
                    value="library.main.SELECT_ALL"
                    count={listIdAllByTerm?.length}
                  />
                </Element>
              )}

              <Tooltip isI18n tooltipContent="library.main.DELETE">
                <Element
                  className={classes.icon}
                  style={{ backgroundColor: '#f2f7ff' }}
                  onClick={handleDelete}
                >
                  <Icon
                    style={{ color: '#2C73E8', fontSize: 16 }}
                    className="icon-trash-fill"
                  />
                </Element>
              </Tooltip>

              <Tooltip isI18n tooltipContent="library.main.ADD_CART">
                <AddToCart isFactSheet isFromLibrary>
                  {(handleAddCart) => {
                    return (
                      <Element
                        className={classes.icon}
                        style={{ backgroundColor: '#f2f7ff' }}
                        onClick={() => {
                          handleBuyAndAddCart(true, handleAddCart)
                        }}
                      >
                        <Icon
                          style={{ color: '#3DA967', fontSize: 16 }}
                          className="icon-add-shopping-cart"
                        />
                      </Element>
                    )
                  }}
                </AddToCart>
              </Tooltip>

              <Tooltip isI18n tooltipContent="library.main.BUY_FIIN">
                <AddToCart isFactSheet isFromLibrary>
                  {(handleAddCart) => {
                    return (
                      <Element
                        className={classes.icon}
                        style={{ backgroundColor: '#f2f7ff' }}
                        onClick={() => {
                          handleBuyAndAddCart(false, handleAddCart)
                        }}
                      >
                        <Icon
                          style={{ color: '#3DA967', fontSize: 16 }}
                          className="icon-money"
                        />
                      </Element>
                    )
                  }}
                </AddToCart>
              </Tooltip>

              <Tooltip isI18n tooltipContent="library.main.COPY">
                <Element
                  className={classes.icon}
                  style={{ backgroundColor: '#f2f7ff' }}
                  onClick={() => {
                    setShowCopy(true)
                  }}
                >
                  <Icon
                    style={{ color: '#FFCB1E', fontSize: 16 }}
                    className="icon-folder-plus"
                  />
                </Element>
              </Tooltip>
            </>
          )}
        </Element>
      )}

      {isShowDelete && (
        <PopupDeleteCompany
          isShow={isShowDelete}
          setShow={setIsShowDelete}
          onSubmit={onSubmitDelete}
          renderContent={() => (
            <TranslateRemoveMultiCompany
              count={numberIdSelected}
              portfolioName={textFollowing}
            />
          )}
        />
      )}
      {isShowCopy && (
        <PopupCopyOrMoveCompany
          isShow={isShowCopy}
          setShow={setShowCopy}
          type={TYPE_POPUP_MOVE_COPY.COPY}
          handleApply={onSubmitCopy}
          numberCompany={[...getListIdSelectByObj(checkboxObj)].length}
        />
      )}
    </>
  )
}
